// extracted by extract-css-chunks-webpack-plugin
module.exports = {"col_box":"col_box-2TdOvxFI","col_navlist":"col_navlist-EWSC-BN6"};